"use strict";

import React, {useState} from 'react';

const ProductGallerySlideCaption = ({caption='',}) => {
    const [showCaption, setShowCaption] = useState(true);
    function onCaptionActionClick(e){
        e.preventDefault();
        setShowCaption(!showCaption);
    }
    if(!!caption){
        return (
            <div className={`slide__caption__container ${!showCaption && 'slide__caption__container--is-closed'}`}>
                <div className={`slide__caption`}>
                    {caption}
                </div>
                <a href="#"
                   onClick={onCaptionActionClick}
                   title={`${showCaption ? 'Close' : 'Show'} Product Image Caption`}
                   className={`btn__delete slide__caption__action__link`} />
            </div>
        );
    }
    return null;
};

export default ProductGallerySlideCaption;
